import { Button } from '@mui/material';
import Container from '@mui/material/Container';
import PermissionBasedGuard from 'src/auth/guard/permission-based-guard';
import { useAuthContext } from 'src/auth/hooks';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs/custom-breadcrumbs';
import Iconify from 'src/components/iconify';
import { RouterLink } from 'src/routes/components';
import { paths } from 'src/routes/paths';
import RestaurantSubscriptionsListView from './restaurant-subscriptions-list-view';

// ----------------------------------------------------------------------

export default function RestaurantSubscriptionsPageView() {
  const { user } = useAuthContext();

  if (!user?.restaurants[0]?.id) {
    return <div>No restaurant found</div>;
  }

  return (
    <PermissionBasedGuard permissions={['partners:read:subscriptions']} hasContent>
      <Container maxWidth={false}>
        <CustomBreadcrumbs
          heading="Subscriptions"
          sx={{ mb: 2 }}
          links={[{}]}
          action={
            user.restaurants.length == 1 &&
            user?.restaurants[0].id && (
              <PermissionBasedGuard permissions={['partners:create:subscriptions']}>
                <Button
                  component={RouterLink}
                  href={paths.dashboard.restaurant.subscription.add(
                    user.restaurants[0].id.toString()
                  )}
                  variant="contained"
                  startIcon={<Iconify icon="mingcute:add-line" />}
                >
                  Add Subscription
                </Button>
              </PermissionBasedGuard>
            )
          }
        />
      </Container>
      <RestaurantSubscriptionsListView />
    </PermissionBasedGuard>
  );
}
